import React from "react";
import { observer } from "mobx-react";
import { action, observable } from "mobx";
import { Alert, Badge } from "reactstrap";

import { applyDecorators } from "@app/Helpers/Decorator";
import { BannerModel } from "@app/Models/WebApiModels";
import { DateTimeService } from "@app/Services/DateTimeService";
import "./_banner-item.scss";

type BannerItemProps = {
    item: BannerModel;
    canHide?: boolean;
    showPersonInfo?: boolean;
    renderActions?: () => JSX.Element;
};

@observer
export class BannerItem extends React.Component<BannerItemProps> {
    @observable private _isOpen: boolean = true;

    constructor(props: BannerItemProps) {
        super(props);
        applyDecorators(this);
    }

    render() {
        const { item, showPersonInfo, canHide, renderActions } = this.props;

        return (
            <Alert color="warning" className="banner-item" isOpen={this._isOpen} toggle={canHide ? this._onDismiss : undefined}>
                <div className="banner-item-actions">
                    {renderActions?.()}
                </div>
                {item.title && <div className="banner-item-title">{item.title}</div>}
                <div className="banner-item-content">
                    <div dangerouslySetInnerHTML={{ __html: (item.text || '') }} />
                </div>
                {showPersonInfo && (
                    <div className="d-flex justify-content-end gap-2 mt-2">
                        <Badge color="warning">Created at: {DateTimeService.toUiDateTime(item.createdAt)}</Badge>
                        <Badge color="warning">Created by: {item.createdBy}</Badge>
                        {item.modifiedAt && <Badge color="warning">Modified at: {DateTimeService.toUiDateTime(item.modifiedAt)}</Badge>}
                        {item.modifiedAt && <Badge color="warning">Modified by: {item.modifiedBy}</Badge>}
                    </div>
                )}
            </Alert>
        );
    }

    @action.bound
    private _onDismiss() {
        this._isOpen = false;
    }
}